"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSheetDrag = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useSheetDrag = function useSheetDrag(_ref) {
  var onClose = _ref.onClose,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 100 : _ref$threshold;
  var startYRef = (0, _react.useRef)(null);
  var draggingRef = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      translateY = _useState2[0],
      setTranslateY = _useState2[1];

  var isTouchEvent = function isTouchEvent(e) {
    return 'touches' in e;
  };

  var getClientY = function getClientY(e) {
    var _e$touches$;

    return isTouchEvent(e) ? (_e$touches$ = e.touches[0]) === null || _e$touches$ === void 0 ? void 0 : _e$touches$.clientY : e.clientY;
  };

  var handleMove = function handleMove(clientY) {
    if (!draggingRef.current || startYRef.current == null) return;
    var deltaY = clientY - startYRef.current;
    if (deltaY > 0) setTranslateY(deltaY);
  };

  var handleEnd = function handleEnd(clientY) {
    var _startYRef$current;

    draggingRef.current = false;
    var deltaY = clientY - ((_startYRef$current = startYRef.current) !== null && _startYRef$current !== void 0 ? _startYRef$current : 0);

    if (deltaY > threshold) {
      if (onClose) onClose();
    }

    setTranslateY(0);
    startYRef.current = null;
  };

  var handleMoveMouse = function handleMoveMouse(e) {
    return handleMove(e.clientY);
  };

  var handleMoveTouch = function handleMoveTouch(e) {
    var _e$touches$2;

    return handleMove((_e$touches$2 = e.touches[0]) === null || _e$touches$2 === void 0 ? void 0 : _e$touches$2.clientY);
  };

  var handleEndMouse = function handleEndMouse(e) {
    handleEnd(e.clientY);
    document.removeEventListener('mousemove', handleMoveMouse);
    document.removeEventListener('mouseup', handleEndMouse);
  };

  var handleEndTouch = function handleEndTouch(e) {
    var _e$changedTouches$;

    handleEnd((_e$changedTouches$ = e.changedTouches[0]) === null || _e$changedTouches$ === void 0 ? void 0 : _e$changedTouches$.clientY);
    document.removeEventListener('touchmove', handleMoveTouch);
    document.removeEventListener('touchend', handleEndTouch);
  };

  var handleStart = function handleStart(e) {
    if (disabled) return;
    var nativeEvent = e.nativeEvent;
    draggingRef.current = true;
    startYRef.current = getClientY(nativeEvent);
    var moveHandler = isTouchEvent(nativeEvent) ? handleMoveTouch : handleMoveMouse;
    var endHandler = isTouchEvent(nativeEvent) ? handleEndTouch : handleEndMouse;
    document.addEventListener(isTouchEvent(nativeEvent) ? 'touchmove' : 'mousemove', moveHandler);
    document.addEventListener(isTouchEvent(nativeEvent) ? 'touchend' : 'mouseup', endHandler);
  };

  return {
    translateY: translateY,
    dragging: draggingRef.current,
    handleStart: handleStart
  };
};

exports.useSheetDrag = useSheetDrag;